export default Object.freeze({
  Pending: 0,
  Success: 1,
  Error: 2,
});
